export default __webpack_public_path__ + "static/media/news-lt.6b865558.png";